import axios from "axios";
import {
  type MethodsInput,
  CreateMethodsInputRequest,
} from "../../types/model/methodsInput";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/calculations/captures`;

export const createMethodsInput = async (
  captureId: number,
  payload: CreateMethodsInputRequest,
): Promise<MethodsInput> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.post(
    `${BASE_URL}/${captureId}/methods-input`,
    payload,
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
